export default [
    {
      path: '/admin/product-specifications',
      name: 'product-specification',
      meta: { requiresAuth: true },
      component: () => import('@/pages/product/specification')
    },
  ]